import React from "react";
import "components/Skeletons/TextSkeleton/TextSkeleton.css";

function TextSkeleton() {
  return <div className="text-skeleton skeleton-loader"></div>;
}

export default TextSkeleton;
